<script>
import appConfig from "@/app.config";

import { notificationMethods } from "@/state/helpers";

import { mapState, mapActions } from "vuex";
import DomainError from "@/pages/views/login/DomainError.vue";
import { getDomainSettings } from "@/services/modules/domain/domainService";
import EncryptionHelper from "../helpers";

export default {
  name: "app",
  components: {
    DomainError,
  },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  data() {
    return {
      currentUrl: window.location.host,
      title: null,
      imageSrc: null,
      ipAddress: null,
      port: null,
      newUrl: null,
      description: null,
    };
  },
  computed: {
    ...mapState("process", ["processLoading"]),
  },
  async created() {
    await this.fetchUrl();
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
  },
  methods: {
    ...mapActions("settings", ["fetchLogo"]),
    clearNotification: notificationMethods.clear,
    async fetchUrl() {
      let formattedUrl = this.editUrl(this.currentUrl);
      if (formattedUrl.includes("local") || formattedUrl.includes("192.168")) {
        formattedUrl = "test.b2b.ofiscom.net";
        localStorage.setItem("currentUrl", formattedUrl);
      } else {
        localStorage.setItem("currentUrl", formattedUrl);
      }
      const response = await getDomainSettings(formattedUrl);
      const encryptionHelper = new EncryptionHelper(
        process.env.VUE_APP_API_SECURITY_KEY
      );


      const decrypt = (encryptedValue) => {
        const decryptedValue = encryptionHelper.decrypt(encryptedValue);
        return decryptedValue;
      };

      try {
        response.status;
        this.title = decrypt(response.data.data.title);
        this.imageSrc = decrypt(response.data.data.companyLogo);
        this.port = decrypt(response.data.data.port);
        this.description = decrypt(response.data.data.description);
        this.ipAddress = decrypt(response.data.data.ipAddress);
        this.fetchLogo(this.imageSrc);
        localStorage.setItem("ipAddress", this.ipAddress);
        localStorage.setItem("description", this.description);
        localStorage.setItem("title", this.title);
        localStorage.setItem("port", this.port);
        localStorage.setItem("logo", this.imageSrc);
      } catch (error) {
        console.error(error);
      }
    },
    editUrl(url) {
      return url.replace(/^(https?:\/\/)/, "");
    },
  },
};
</script>

<template>
  <div id="app">
    <RouterView v-if="this.ipAddress" />
    <v-overlay :value="processLoading" opacity="1" z-index="999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <domain-error v-if="!this.ipAddress"></domain-error>
  </div>
</template>
